import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import apiService from '../services/api.service';
import './Blog.css';

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState('');
  const [categorySlug, setCategorySlug] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchBlogs();
    }, 300);

    return () => clearTimeout(timer);
  }, [search, categorySlug]);

  const fetchCategories = async () => {
    try {
      const response = await apiService.getCmsBlogCategories();
      setCategories(response.data || []);
    } catch (err) {
      console.error('Error fetching CMS blog categories:', err);
    }
  };

  const fetchBlogs = async () => {
    try {
      setLoading(true);
      setError('');
      const params = {
        page: 1,
        pageSize: 50
      };

      if (search.trim()) {
        params.search = search.trim();
      }

      if (categorySlug) {
        params.categorySlug = categorySlug;
      }

      const response = await apiService.getCmsBlogs(params);
      setBlogs(response.data.items || []);
    } catch (err) {
      console.error('Error fetching CMS blogs:', err);
      setError('Unable to load blogs right now. Please try again later.');
      setBlogs([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <>
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>Blog</h2>
            </div>
          </div>
        </div>
      </div>

      <section className="blog-list-section">
        <div className="container">
          <div className="section-header text-center">
            <p>Our Blog</p>
            <h2>Latest News & Updates</h2>
          </div>

          <div className="blog-filter-card">
            <div className="blog-search-field">
              <i className="fas fa-search"></i>
              <input
                type="text"
                value={search}
                onChange={(event) => setSearch(event.target.value)}
                placeholder="Search blogs by title"
              />
            </div>
            <select
              value={categorySlug}
              onChange={(event) => setCategorySlug(event.target.value)}
              aria-label="Filter blogs by category"
            >
              <option value="">All Categories</option>
              {categories.map((category) => (
                <option key={category.slug} value={category.slug}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>

          {error && <div className="blog-alert">{error}</div>}

          {loading ? (
            <div className="blog-state">Loading blogs...</div>
          ) : blogs.length === 0 ? (
            <div className="blog-state">No blogs found for your search.</div>
          ) : (
            <div className="row">
              {blogs.map((blog) => (
                <div key={blog.slug} className="col-lg-4 col-md-6">
                  <article className="blog-list-card">
                    <div className={`blog-list-image ${!blog.featuredImageUrl ? 'blog-list-image-placeholder' : ''}`}>
                      {blog.featuredImageUrl ? (
                        <img
                          src={blog.featuredImageUrl}
                          alt={blog.title}
                          onError={(event) => {
                            event.currentTarget.style.display = 'none';
                            event.currentTarget.parentElement.classList.add('blog-list-image-placeholder');
                          }}
                        />
                      ) : (
                        <i className="far fa-newspaper"></i>
                      )}
                    </div>
                    <div className="blog-list-content">
                      <div className="blog-list-meta">
                        {blog.publishedUtc && <span>{formatDate(blog.publishedUtc)}</span>}
                        {blog.categoryName && <span>{blog.categoryName}</span>}
                      </div>
                      <h3>
                        <Link to={`/blog/${blog.slug}`}>{blog.title}</Link>
                      </h3>
                      {blog.excerpt && <p>{blog.excerpt}</p>}
                      <Link className="blog-list-link" to={`/blog/${blog.slug}`}>
                        Read Article
                      </Link>
                    </div>
                  </article>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Blog;
